import { helpbuttonStyle, convertToLocalStyle, getFluctuationPopupStyle, getFluctuationLoadingStyle } from '@bingads-webui-campaign-react/common-styles';

import conversionTrackingSetupImg from '../media/conversionTracking/ConversionTrackingSetup.svg';
import couponStepOneImg from '../media/conversionTracking/CouponStepOne.svg';
import couponStepTwoImg from '../media/conversionTracking/CouponStepTwo.svg';

export const getConversionTrackingCardStyle = palette => ({
  '@global': {
    ...getFluctuationPopupStyle({ palette }),
    ...getFluctuationLoadingStyle(),
    '.bingads-fluctuation-wrapper .card-holder__wrapper': {
      minWidth: '20px !important',
      border: 'none !important',
      flexDirection: 'row !important',
      boxShadow: 'none !important',
      marginBottom: -4,

      '& .left.carousel-control': {
        left: '5px !important',
      },

      '& .right.carousel-control': {
        right: '0px !important',
        width: '35px !important',
      },
    },
  },


  '.conversion-tracking-card': {
    ...convertToLocalStyle(helpbuttonStyle({ palette })),

    '& .coupon-step-one-image': {
      backgroundImage: `url(${couponStepOneImg})`,
    },

    '& .coupon-step-two-image': {
      backgroundImage: `url(${couponStepTwoImg})`,
    },
    '& .conversion-empty-state': {
      height: '100%',
      width: '100%',
      paddingBottom: 15,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 1,
      justifyContent: 'space-around',

      '& .coupon-text': {
        fontSize: 20,
        fontWeight: 600,
        color: '#323130',
        textAlign: 'center',
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'Segoe UI',
        fontStyle: 'normal',
      },

      '& .coupon-steps-container': {
        display: 'flex',
        flexDirection: 'row',
        '& .step-image-container': {
          height: 150,
          width: 150,
          display: 'flex',
        },
        '& .step': {
          width: '50%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          '& .step-image': {
            flex: 1,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
          },
        },
      },
      '& .title-text': {
        fontSize: 16,
        fontWeight: 600,
        fontFamily: 'Segoe UI',
        order: 1,
        height: 30,
      },
      '& .subtitle-text': {
        fontSize: 12,
        fontFamily: 'Segoe UI',
        height: 40,
        order: 2,
      },
      '& .conversion-image-container': {
        minWidth: '0.1px',
        display: 'flex',
        justifyContent: 'flex-end',
        order: 0,
        flexDirection: 'column',
        flex: 1,
        marginBottom: 20,
      },
      '& .conversion-image': {
        flex: 1,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      },
      '& .conversion_tracking_setup_img': {
        backgroundImage: `url("${conversionTrackingSetupImg}")`,
      },

      '& .entity-links': {
        order: 3,
        marginTop: 10,
      },
    },

    '& .conversion-tracking-state': {
      height: '100%',
      paddingBottom: 0,
      display: 'flex',
      flexDirection: 'column',
      fontSize: 12,
      minHeight: 1,

      '& .conversion-trackig-tile-error-status': {
        display: 'flex',
        flex: '1',
        justifyContent: 'space-between',
        position: 'relative',

        '& .alert-group': {
          minWidth: 35,
          height: 85,
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'nowrap',
          justifyContent: 'center',
          justifyItems: 'center',
          alignContent: 'center',
          alignItems: 'center',

          '& .alert-text': {
            fontSize: 12,
            fontWeight: 600,
            fontStyle: 'normal',
            fontFamily: 'Segoe UI',
            color: '#D13438',
          },
          '& .alert-number': {
            fontSize: 30,
            fontWeight: 700,
            fontStyle: 'normal',
            color: '#D13438',
            fontFamily: 'Segoe UI',
          },
        },

        '& .details-group': {
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'nowrap',
          alignItems: 'flex-start',
          width: '85%',
          '& .title-group': {
            display: 'grid',
            alignContent: 'space-evenly',
            justifyContent: 'start',
            marginTop: '8px',

            '& .status-overview-title': {
              fontSize: 18,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: 'Segoe UI',
              color: '#323130',
            },
            '& .status-overview-subtitle': {
              marginTop: '16px',
              fontSize: 12,
              fontWeight: 400,
              fontStyle: 'normal',
              fontFamily: 'Segoe UI',
              color: '#605E5C',
            },
          },
          '& .errors-group': {
            marginTop: '24px',
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'nowrap',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            '& .error-status': {
              fontSize: 12,
              fontWeight: 600,
              fontStyle: 'normal',
              color: '#323130',
              fontFamily: 'Segoe UI',
              '& .error-status-number': {
                display: 'inline',
                color: '#D13438',
                borderBottom: '1px dashed #0078D4',
              },
            },
          },
        },
      },
      '& .conversion-tracking-grid-header': {
        display: 'flex',
        margin: '15px 0 0px',
        alignItems: 'flex-start',
        '& .popComparisonRange': {
          flex: '1',
          marginRight: 15,
          color: palette.neutralSecondary,
          display: 'inline-flex',
        },
        '& .popComparisonRange .helpbutton': {
          marginLeft: 5,
        },
        '& .conversion-goals-card_metric': {
          flex: '0',
        },
        '& .metric-container': {
          marginRight: 20,
          '& .dropdown-toggle': {
            height: 'inherit',
          },
        },
      },
      '& .conversion-tracking-grid-container': {
        display: 'flex',
        flex: '1 1',
        justifyContent: 'center',
        overflowY: 'auto',
        overflowX: 'hidden',

        '& .conversion-tracking-grid-empty': {
          alignSelf: 'center',
          fontSize: '14px',
        },
        '& .conversion-goals-grid': {
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 25%) minmax(0, 20%) minmax(0, 20%) minmax(max-content, max-content) minmax(max-content, 1fr)',
          alignItems: 'stretch',
          flex: '1',
          alignSelf: 'flex-start',

          '& .conversion-goals-grid-row-10': {
            gridRow: '10',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-9': {
            gridRow: '9',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-8': {
            gridRow: '8',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-7': {
            gridRow: '7',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-6': {
            gridRow: '6',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-5': {
            gridRow: '5',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-4': {
            gridRow: '4',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-3': {
            gridRow: '3',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-2': {
            gridRow: '2',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },
          '& .conversion-goals-grid-row-1': {
            gridRow: '1',
            borderTop: `1px solid ${palette.neutralLighter}`,
          },

          '& .conversion-goals-entity-name': {
            gridColumn: '1',
            borderRight: '1px solid #EFEFEF',
            display: 'flex',
            alignItems: 'center',
            minHeight: 48,
            paddingLeft: 10,
            paddingRight: 10,
          },
          '& .conversion-goals-entity-name .status': {
            marginRight: 5,
          },
          '& .conversion-goals-entity-name a': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 1,
            whiteSpace: 'nowrap',
          },
          '& .conversion-goals-graph-decline': {
            gridColumn: '2',
            borderRight: '1px solid #CBCBCB',
            padding: '5px 0 5px 5px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: palette.neutralLighter,
          },
          '& .conversion-goals-graph-decline .decline-box': {
            display: 'flex',
            height: 30,
            width: '100%',
          },
          '& .conversion-goals-graph-decline .decline-box .graph-bar': {
            backgroundColor: palette.themePrimary,
          },
          '& .conversion-goals-graph-increase': {
            gridColumn: '3',
            borderRight: '1px solid #EFEFEF',
            padding: '5px 5px 5px 0',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: palette.neutralLighter,
          },
          '& .conversion-goals-graph-increase .increase-box': {
            display: 'flex',
            height: 30,
            width: '100%',
          },
          '& .conversion-goals-graph-increase .increase-box .graph-bar': {
            backgroundColor: '#01188F',
          },
          '& .pop-change': {
            gridColumn: '5',
            fontSize: 15,
            color: palette.neutralPrimary,
            paddingLeft: 10,
            paddingTop: 12,
            textAlign: 'right',
          },
          '& .pop-change-percentage': {
            gridColumn: '6',
            fontSize: 12,
            color: palette.neutralSecondary,
            paddingLeft: 15,
            paddingTop: 15,
            textAlign: 'right',
          },
          '& .pop-range': {
            gridColumn: '7',
            fontSize: 12,
            color: palette.neutralSecondary,
            paddingLeft: 15,
            paddingRight: 26,
            paddingTop: 15,
            textAlign: 'right',
          },
          '& .graph-hover-target': {
            gridColumn: '2 / span 2',
            background: 'none',
            zIndex: '1',
            border: 'none !important',
          },
          '& .pop-hover-target': {
            gridColumn: '5 / span 2',
            background: 'none',
            zIndex: '1',
            border: 'none !important',
          },
          '& .graph-hover-target:hover .hover-container': {
            display: 'block',
          },
          '& .pop-hover-target:hover .hover-container': {
            display: 'block',
          },
          '& .kpi-increased .bar-icon': {
            display: 'inline-block',
            backgroundColor: '#01188F',
          },
          '& .kpi-declined .bar-icon': {
            display: 'inline-block',
            backgroundColor: '#0078D7',
          },
          '& .bar-icon': {
            display: 'none',
            width: 12,
            height: 12,
            marginRight: 3,
          },
          '& .pop-hover-target .hover-container .hover-content': {
            right: '-150px',
          },
          '& .graph-hover-target .hover-container .hover-content': {
            left: '-150px',
          },
          '& .hover-container': {
            position: 'absolute',
            display: 'none',
            fontSize: 12,
            color: '#333333',
            width: '0',
            height: '0',
            marginLeft: 5,

            '& .hover-content': {
              position: 'absolute',
              zIndex: '10',
              padding: 15,
              bottom: '0',
              borderRadius: 2,
              boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              '@supports (backdrop-filter: blur(60px))': {
                backdropFilter: 'blur(60px)',
                backgroundColor: 'rgba(255, 255, 255, 0.25)',
              },
            },
            '& .hover-content:hover': {
              display: 'none',
            },
            '& .hover-content .entity-name': {
              wordBreak: 'break-all',
              paddingBottom: 10,
            },
            '& .hover-content .kpi-grid': {
              display: 'grid',
              gridTemplateColumns: 'minmax(max-content, max-content) minmax(max-content, max-content)',
            },
            '& .hover-content .kpi-grid .kpi-date-range': {
              paddingBottom: 10,
            },
            '& .hover-content .kpi-grid .kpi-data': {
              fontWeight: 'bold',
            },
            '& .hover-content .kpi-grid .kpi-current': {
              maxWidth: '240px',
              gridRow: '1',
              gridColumn: '1',
              borderRight: '1px solid #DDDDDD',
              paddingRight: 15,
            },
            '& .hover-content .kpi-grid .kpi-comparison': {
              maxWidth: '240px',
              gridColumn: '2',
              paddingLeft: 15,
            },
            '& .hover-content .kpi-grid .kpi-change': {
              gridRow: '2',
              gridColumn: '1 / span 2',
              paddingTop: 10,
              display: 'flex',
              alignItems: 'center',
            },
          },
          '& .conversion-goals-grid-row-1 .hover-container .hover-content, .conversion-goals-grid-row-2 .hover-container .hover-content': {
            top: 48,
            bottom: 'auto',
          },
        },
        '& .scroll-bar-cover': {
          position: 'absolute',
          background: 'white',
        },
        '&:hover .scroll-bar-cover': {
          display: 'none',
        },
      },

      '& .carousel-footer': {
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: 15,

        '& .btn-primary': {
          fontWeight: 'bold',
          fontSize: 14,
          height: '32px',
          backgroundColor: palette.white,
          color: palette.black,
          padding: '0px 0px',
          borderRadius: '2px',
          border: '1px solid',
          borderColor: '#8a8886',

          minWidth: '200px',
          '&:hover': {
            backgroundColor: '#f3f2f1',
          },
        },
        '& .carousel-pagination': {
          minWidth: 150,
          display: 'flex',
          fontSize: 14,
          justifyContent: 'space-between',
          alignItems: 'center',

          '& .carousel-item-count': {
          },
          '& .carousel-arrows': {
            minWidth: 50,
            justifyContent: 'center',
            textShadow: 'none',
            color: palette.themePrimary,

            '&:hover': {
              color: palette.themeDarker,
            },
          },
        },
      },
    },
    ' .conversion-tracking-empty-state': {
    },

    '& .entity-links': {
      marginTop: 10,
    },
    '& .entity-links .view-all-clickLink': {
      flex: '0 0 auto',
    },
    '& .metric-picker': {
      padding: '0',
      border: '0',
      fontWeight: '600',
      margin: '0',
      fontSize: 12,
      lineHeight: 'normal',
      fallbacks: [
        {
          fontWeight: 'normal',
        },
      ],
    },
  },
});
